<div class="modal-background" bdFxLayoutAlign="center start" (click)="onModalBackgroundClicked()">
    <div class="modal-window">
        <div class="header">
            <div class="title">
                Achtung
            </div>
            <bd-fa-button [name]="'times'" (click)="onCancelBtnClicked()"></bd-fa-button>
        </div>
        <form class="message-container" #priceApprovalCommentForm="ngForm">
            <div class="message">Möchten Sie die Preise für dieses Angebot {{ getActiveModeTranslation() }}?</div>
            <bd-labeled-textarea [placeholder]="'Kommentar eingeben (Max. 200 Zeichen)*'"
                                 name="comment"
                                 [(ngModel)]="model.comment"
                                 [maxlength]="'200'"
                                 [required]="isCommentRequired()"
                                 limitTo="200">
            </bd-labeled-textarea>

            <div class="buttons-container">
                <button type="button" (click)="onDeclineBtnClicked()" class="btn-summary-secondary">
                    Nein, abbrechen
                </button>
                <button type="submit" (click)="onConfirmBtnClicked()"
                        [disabled]="priceApprovalCommentForm.invalid">
                    Ja, {{ getActiveModeTranslation()}}

                </button>
            </div>
        </form>
    </div>
</div>
